module.exports = __webpack_public_path__ + "img/BE0819210332.5cf8430a.png";